import React, { useEffect, useState } from "react";
import filteringProps from "../filtering/vendors.json";
import { getUser, hasRole, setPage, toPrettyDate, useHub, useScreen, validateRole } from "../../../core/Global";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { DataTable, DataTableField } from "../../../components/data/DataTable";
import { API_ROUTES } from "../../../core/Constants";
import Modal from "../../../components/base/Modal";
import TextBox from "../../../components/form/TextBox";
import { toastSuccess } from "../../../components/base/Toast";
import { VendorModel } from "../models/VendorModel";
import TextArea from "../../../components/form/TextArea";
import Tagify from "../../../components/tagify/Tagify";
import Avatar from "../../../components/base/Avatar";
import { DrawerForm } from "../../../components/drawers/DrawerForm";

export default function VendorsListView() {

  const hub = useHub()
  const user = getUser()
  const screen = useScreen()

  const [createForm, createFormSet] = useState<boolean>(false)
  const [updateForm, updateFormSet] = useState<boolean>(false)
  const [deleteModal, deleteModalSet] = useState<boolean>(false)
  const [deleteRes, deleteResSet] = useState<any>(true)

  const [selectedItem, selectedItemSet] = useState<VendorModel>()


  const [refresh, refreshSet] = useState<boolean>();

  const edit = (data: any) => {
    selectedItemSet(data);
    updateFormSet(true);
  }

  const deleteVendor = (data: any) => {
    selectedItemSet(data);
    deleteModalSet(true);
  }


  const NameItem = (data: VendorModel) => (
    <FlexRow onClick={() => edit(data)}>
      <div className="ms-2">
        {data.name}
      </div>
      <a href="#" className="ms-1"
        onClick={e => {
          e.preventDefault();
          edit(data);
        }}>
        <Icon icon="edit" className="ms-2" size={12} />
      </a>
    </FlexRow>
  )

  const CountriesItem = (data: VendorModel) => (
    <FlexRow onClick={() => edit(data)}>
      {
        data.countries && data.countries.length > 0 ?
          <>
            {
              data.countries?.map((cnt, k) =>
                <span key={k} className="badge badge-secondary me-2">
                  <Avatar avatarUrl={cnt.flagSquare} width={20} className="me-2" />
                  {cnt.name}
                </span>
              )
            }
          </>
          :
          <>
            <span className="badge badge-secondary me-2">
              <Icon icon="globe" size={18} className="text-gray-600 me-2" />
              Global
            </span>
          </>
      }

    </FlexRow>
  )

  const CreatedItem = (data: VendorModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  const ModifiedItem = (data: VendorModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.modifiedAt)}
      </div>
      {
        data.modifiedUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.modifiedUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  useEffect(() => {

    validateRole("ManageVendors");
    setPage("Vendors", "Inventory", "Base Data");

  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }
  }, [refresh])

  return (
    <>

        <DataTable
          objectName="Vendor"
          apiRoute={API_ROUTES.InventoryVendors}
          filteringProps={filteringProps}
          // sortingProps={sortingProps}
          addCustom={() => createFormSet(true)}
          edit editCustom={edit}
          delete={hasRole("DeleteVendors")} deleteCustom={deleteVendor}
          refresh={refresh}>

          <DataTableField title="Name">
            <NameItem />
          </DataTableField>

          <DataTableField title="Countries">
            <CountriesItem />
          </DataTableField>

          <DataTableField title="Description" dataValueName="description" />

          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>

          <DataTableField title="Modified">
            <ModifiedItem />
          </DataTableField>

        </DataTable>



      {
        (createForm || updateForm) &&
        <DrawerForm id="drawer-vendor-form"
          title={(createForm ? "Create Vendor" : "Edit Vendor")}
          buttonText={(createForm ? "Create Vendor" : "Update Vendor")}
          onClose={() => {
            createFormSet(false)
            updateFormSet(false)
            selectedItemSet(undefined)
          }}
          focusOn="txt-vendor-name"
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("names", "Please write a valid name!", "drawer-vendor-form", true);
              if (callback) callback();
              return;
            }

            hub.Post(API_ROUTES.InventoryVendors, {
              ...body,
              id: selectedItem?.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess(`Vendor has been ${(createForm ? "added" : "updated")} successfully!`);
              }
              if (callback) callback(res);
            })
          }}>

          <TextBox id="txt-vendor-name" name="name" label="Name" marginBottom={5}
            labelUp block value={selectedItem?.name} />

          <Tagify id="txt-vendor-countries" name="countries" marginBottom={5}
            apiUrl={API_ROUTES.TagifyCountries} labelUp block label="Countries"
            selectedIds={selectedItem?.countryIds} />

          <TextArea id="txt-vendor-descr" name="description"
            label="Description" labelUp block rows={6} value={selectedItem?.description}
            placeholder="Write a description (optional)" />

        </DrawerForm>
      }


      {
        deleteModal && selectedItem &&
        <Modal id="modal-delete-vendor"
          title="Delete Vendor"
          buttonText="Confirm & Delete"
          buttonColor="danger"
          onOpen={() => {
            // hub.Post(API_ROUTES.InventoryCategories + "verifydelete", {
            //   id: selectedItem.id
            // }, res => deleteResSet(res.data))
          }}
          onClose={() => {
            deleteModalSet(false)
            //deleteResSet(undefined)
            selectedItemSet(undefined)
          }}
          onSubmit={deleteRes ? (body, callback) => {

            hub.Post(API_ROUTES.InventoryVendors + "delete", {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Vendor has been deleted successfully!");
              }
              if (callback) callback(res);
            })

          } : undefined}
          staticBackdrop open visible>
          <div>
            <div className="mb-2">
              Are you sure you want to delete the vendor?
            </div>
            <div className="alert alert-danger">
              {selectedItem.name}
            </div>

          </div>
        </Modal>
      }


    </>
  );
}
